var map = {
	"./retailquantofy.webp": 1290,
	"./retailquantofy10.png": 1763,
	"./retailquantofy2.webp": 7220,
	"./retailquantofy3.webp": 9815,
	"./retailquantofy4.webp": 8282,
	"./retailquantofy5.webp": 2549,
	"./retailquantofy6.webp": 2792,
	"./retailquantofy7.webp": 171,
	"./retailquantofy8.png": 2842,
	"./retailquantofy9.png": 1699
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6768;